<template>
  <svg width="100%" height="100%" viewBox="0 0 18 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.2341 0.582031H2.20085C1.30363 0.582031 0.574951 1.31071 0.574951 2.20793V24.7276H17.855V2.20793C17.855 1.31071 17.1264 0.582031 16.2291 0.582031H16.2341ZM1.82411 4.44849H16.6108V20.9751H1.82411V4.44849ZM2.20085 1.82624H16.2341C16.4423 1.82624 16.6108 1.99478 16.6108 2.20297V3.19933H1.82411V2.20297C1.82411 1.99478 1.99265 1.82624 2.20085 1.82624ZM1.82411 23.4734V22.2193H16.6108V23.4734H1.82411Z"
      fill="currentColor" />
    <path
      d="M12.0156 5.62817H6.42414C6.07715 5.62817 5.79956 5.90577 5.79956 6.25276C5.79956 6.59975 6.07715 6.87734 6.42414 6.87734H12.0156C12.3626 6.87734 12.6402 6.59975 12.6402 6.25276C12.6402 5.90577 12.3626 5.62817 12.0156 5.62817Z"
      fill="currentColor" />
  </svg>
</template>